import { Button, type ButtonProps, Tooltip } from '@mui/material';

import Icon, { type Props as IconProps } from '@@components/Icon/Icon';

export type Props = ButtonProps & { icon?: IconProps; tooltip?: string | boolean };

const SubmitButton = (props: Props) => {
    const { icon, tooltip, ...rest } = props;

    const button = (
        <Button
            startIcon={<Icon {...(icon || { name: 'check', pack: 'sharp' })} />}
            color="success"
            variant="contained"
            type="submit"
            {...rest}
        />
    );

    if (tooltip) {
        return (
            <Tooltip title={tooltip}>
                {/* Needs to be wrapped in span element for tooltip to work */}
                <span tabIndex={0} style={{ display: 'inline-block' }}>
                    {button}
                </span>
            </Tooltip>
        );
    }

    return button;
};

export default SubmitButton;
